import React, { useContext, useState,useEffect,useMemo } from 'react';
import { Table, Button, Icon, Modal, Input, Pagination } from 'semantic-ui-react';
import styles from "./DataConnections.module.css";
import ConfirmationModal from './ConfirmationModal'; // Import the styled confirmation modal
import DublicateConfirmation from './DublicateConfirmation';
import dataconnection from '../../../api/DataConnection/dataconnection';
import axios from 'axios';

const ConnectionList = ({ onEdit, toolapiendpoint ,loadToolApiendpoint,conloaderSatus,setConloaderStatus,resetCOnnectform, variableMode = false, listEditingResetTick = 0 }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [selectedDb, setSelectedDb] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [copyModalOpen, setCopyModalOpen] = useState(false);
    const [copyId, setCopyId] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    
    const recordsPerPage = 5;
    
    // Sort data in descending order by created_at
    const sortedData = useMemo(() => {
        if(toolapiendpoint){
            return [...toolapiendpoint].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        }
    }, [toolapiendpoint]);

    
    
    // Pagination logic
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = sortedData ? sortedData.slice(indexOfFirstRecord, indexOfLastRecord) : [];
    const totalPages = sortedData ? Math.ceil(sortedData.length / recordsPerPage) : 0;

    const handlePageChange = (e, { activePage }) => {
        setCurrentPage(activePage);
    };

    const confirmDelete = () => {
        if (selectedDb) {
            let paramsVariable = {'file_configure_type': variableMode ? 'true' : 'false'}
            setConloaderStatus(true)
            if(variableMode){
                dataconnection.deleteVariableConnectionById(selectedDb.id).then(() => {
                    setSuccessMessage("Configuration deleted successfully!");
                    loadToolApiendpoint();
                    setTimeout(() => setSuccessMessage(""), 6000);
                    
                        closeModal();
                });
            }else{
                dataconnection.deleteDataApiConnection(selectedDb.id).then(() => {
                    setSuccessMessage("Configuration deleted successfully!");
                    loadToolApiendpoint();
                    setTimeout(() => setSuccessMessage(""), 6000);
                    
                        closeModal();
                });
            }
           
            resetCOnnectform(); 
        }
    };

    useEffect(() => {
        if (toolapiendpoint != undefined) {
            setConloaderStatus(false);
        }
    }, [toolapiendpoint]);

    const openModal = (db) => {
        setSelectedDb(db);
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
        setSelectedDb(null);
    };

    useEffect(() => {
        // whenever parent signals a save completed, re-enable delete buttons
        setIsEditing(false);
    }, [listEditingResetTick]);

    const openCopyModal = (id) => {
        setCopyId(id);
        setCopyModalOpen(true);
    };
    
    const closeCopyModal = () => {
        setCopyId(null);
        setCopyModalOpen(false);
    };
    
    const confirmCopy = async () => {
        setCopyModalOpen(false);
        try {
            dataconnection.duplicateDataApiConnection(copyId).then(() => {
            setSuccessMessage("Configuration copied successfully!");
            loadToolApiendpoint();
            setTimeout(() => setSuccessMessage(""), 3000);
            })
            resetCOnnectform();
        } catch (error) {
            setSuccessMessage("Configuration copied successfully!");
            setTimeout(() => setSuccessMessage(""), 3000);
            console.error("Error duplicating config:", error);
           
        } finally {
            setCopyId(null);
        }
    };

    const onRefresh = async (execute_url, authorization) => {
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${execute_url}`,
            headers: { 
                "Authorization": `${authorization.token}`
             }
        };
      
      axios.request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        setSuccessMessage("Configuration Refresh successfully!");
        loadToolApiendpoint();
        setTimeout(() => setSuccessMessage(""), 3000);

      })
      .catch((error) => {
        console.log(error);
      });
      
    };
    


    return (
        <>
        {
            (toolapiendpoint !== undefined && conloaderSatus == false) ?
            <div style={{ marginTop: "20px" }}>
                {sortedData?.length === 0 ? (
                    <p>No connections available. Please add a new data connection.</p>
                ) : (
                    <div className={`${styles.datalayerTable}`}>
                       
                        <div style={{ overflowX: 'auto' }}> 
                        {successMessage && (
                                <div style={{ backgroundColor: "#d4edda", color: "#155724", padding: "10px", marginBottom: "10px", borderRadius: "5px" }}>
                                    {successMessage}
                                </div>
                        )}
                            <Table>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>Name</Table.HeaderCell>
                                        <Table.HeaderCell>My Endpoint</Table.HeaderCell>
                                        {variableMode==false ? (
                                        <Table.HeaderCell>Updated Interval</Table.HeaderCell>
                                        ) : null}
                                        {variableMode==false ? (
                                        <Table.HeaderCell>Add or Replace?</Table.HeaderCell>
                                        ): null}
                                        
                                        <Table.HeaderCell>Actions</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {currentRecords.map((db) => (
                                        <Table.Row key={db.id}>
                                            <Table.Cell className={styles.datalaytd}>{db.endpoint_name}</Table.Cell>
                                            <Table.Cell className={styles.datalaytd}><span className={variableMode ? styles.truncateVariableMode : styles.truncate}> {db.endpoint_url}</span></Table.Cell>
                                            {variableMode==false ? (
                                            <Table.Cell className={styles.datalaytd}>{db.timeInSWC}</Table.Cell>
                                            ) : null}
                                            {variableMode==false ? (
                                            <Table.Cell className={styles.datalaytd}>{db.operation}</Table.Cell>
                                            ) : null}
                                            <Table.Cell className={styles.datalaytd}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                
                                                    {variableMode==false ? (
                                                    <span
                                                    title="Copy Connection"
                                                    onClick={() => openCopyModal(db.id)}
                                                    style={{ cursor: 'pointer' }}
                                                    >
                                                    <i className={`la la-copy ${styles.red || 'text-green-500 hover:text-green-700'}`}></i>
                                                    </span>
                                                    ) : null}
                                                    
                                            <span
                                                    title="Edit Connection"
                                                onClick={() => { setIsEditing(true); onEdit(db); }}
                                                    style={{ cursor: 'pointer' }}
                                                    >
                                                    <i className={`la la-edit ${styles.blue || 'text-blue-500 hover:text-blue-700'}`}></i>
                                                    </span>
                                                    {isEditing ? (
                                                    <span
                                                    title="Delete button is disabled while editing"
                                                    >
                                                    <i className="la la-trash text-grey-500 hover:text-grey-700"></i>
                                                    </span>
                                                    ) : (
                                                    <span
                                                    title="Delete Connection"
                                                    onClick={() => openModal(db)}
                                                    style={{ cursor: 'pointer' }}
                                                    >
                                                    <i className="la la-trash text-red-500 hover:text-red-700"></i>
                                                    </span>
                                                    )}
                                                    
                                                    {variableMode==false ? (
                                                    <span
                                                    title="Refresh Connection"
                                                    onClick={() => onRefresh(db.execute_url, db.authorization)}
                                                    style={{ cursor: 'pointer' }}
                                                    >
                                                    <i className={`la la-refresh ${styles.green || 'text-green-500 hover:text-green-700'}`}></i>
                                                    </span>
                                                    ) : null}
                                                </div>
                                            </Table.Cell>

                                        </Table.Row>
                                    ))}
                                </Table.Body>
                            </Table>
                            {/* Pagination Controls */}
                            <div className={styles.paginationWrapper} style={{ marginTop: "-5px", marginBottom: "11px", paddingBottom: "35px" }}>
                                <Pagination
                                    activePage={currentPage}
                                    totalPages={totalPages}
                                    onPageChange={handlePageChange}
                                />
                            </div>
                        </div>
                    </div>
                )}

                {/* Custom Confirmation Modal */}
                
                    <ConfirmationModal
                        open={modalOpen}
                        onClose={closeModal}
                        onConfirm={confirmDelete}
                        variableMode={variableMode}
                        
                    />
                    <DublicateConfirmation
                        open={copyModalOpen}
                        onClose={closeCopyModal}
                        onConfirm={confirmCopy}
                        message="Are you sure you want to copy this configuration?"
                    />
            </div> :  <p>Loading...</p>
            
        }
        </>
    );
};

export default ConnectionList;
